import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2/station'

/** 获取工位绑定的设备列表 */
export const stationDeviceList = () => {
  return axios.get(`${rootApi}/deviceList`)
}

/** 获取工位叫料清单 */
export const stationCallMaterialList = () => {
  return axios.get(`${rootApi}/callMaterielList`)
}